module.exports = __webpack_public_path__ + "static/media/SmartSuite_Vertical_App.f603d72c.png";